import { ProductExDetailType } from "../interface";
import React, { useEffect } from "react";
import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import { useUpdateProductDetailImageEx } from "../hooks/useUpdateProductDetailImageEx";
import { useParams } from "react-router-dom";
import { useDownloadProductImageEx } from "../hooks/useDownloadProductImageEx";
import { useReadShippingSelectBox } from "../../../../order/orders/create/hooks/useReadShippingSelectBox";
import { PcsDetailType, PcsSubjectElementType } from "../../../../purchase/pcs/detail/interface";
import { pcsDetailInit, pcsSubjectElementInit } from "../../../../purchase/pcs/detail/state";
import { useForm, useWatch } from "react-hook-form";
import { useModal } from "../../../../../hooks";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import DaumPost from "../../../../../components/common/DaumPost";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    product: ProductExDetailType
    appliedNewPShipment: number
}

interface PurchaseSubjectType {
    list: PcsSubjectElementType[]
}

const purchaseSubjectInit: PurchaseSubjectType = {
    list: []
}

export default function Section3({ product, appliedNewPShipment }: PropsType) {
    const { id } = useParams()
    const { handleModal } = useModal();
    const { goToNavigation } = useGoToNavigation();

    const productDetail = product.productDetail
    const erpProductImageVO = product.erpProductImageVO
    const searchProductWithAccountDetailRes = product.searchProductWithAccountDetailRes
    const deliveryDestinationList = product.deliveryDestinationList

    const { data: shipmentList } = useReadShippingSelectBox()
    const { mutate: mutateUpdateProductDetailImageEx } = useUpdateProductDetailImageEx()
    const { mutate: mutateDownloadProductImage } = useDownloadProductImageEx()

    const { register, getValues, setValue, control, handleSubmit, watch } = useForm({
        defaultValues: pcsDetailInit
    })

    const {
        register: registerSubject,
        getValues: getValuesSubject,
        setValue: setValueSubject,
        control: controlSubject,
        handleSubmit: handleSubmitSubject,
        watch: watchSubject
    } = useForm({
        defaultValues: purchaseSubjectInit,
    })

    const purchaseDetail = {
        ...pcsDetailInit,
        ...useWatch<PcsDetailType>({ control }),
    } as PcsDetailType

    const purchaseSubject = {
        ...{ list: [] },
        ...useWatch<PurchaseSubjectType>({ control: controlSubject }),
    } as PurchaseSubjectType

    const imageUpdateCallback = (files: File[]) => {
        const fd = new FormData()

        if (files.length !== 0) {
            fd.append("file", files.at(0) as File)
            fd.append("newErpProductid", id as string)

            mutateUpdateProductDetailImageEx(fd)
        }
    }

    const btnImageDownload = () => {
        erpProductImageVO && mutateDownloadProductImage(erpProductImageVO)
    }

    const btnCart = () => {
        alert("WIP")
    }

    const btnBuy = (data: PcsDetailType) => {
        if (purchaseDetail.newPShipment === 0) {
            handleModal({
                isOpen: true,
                contents: "배송방법을 선택해주세요.",
                type: "alert"
            })
        } else if (purchaseDetail.newLAddressValue.replaceAll(" ", "") === "" && purchaseDetail.address1 === "") {
            handleModal({
                isOpen: true,
                contents: "주소를 입력해주세요.",
                type: "alert"
            })
        } else if (purchaseDetail.newDtRequestShipment === "") {
            handleModal({
                isOpen: true,
                contents: "납품희망일을 입력해주세요.",
                type: "alert"
            })
        } else if (purchaseSubject.list.at(0)?.newIQty === 0) {
            handleModal({
                isOpen: true,
                contents: "수량이 0입니다.",
                type: "alert"
            })
        } else {
            handleModal({
                isOpen: true,
                contents: "구매 페이지로 이동하시겠습니까?",
                type: "confirm",
                callback: () => {
                    goToNavigation("purchase/pcs/create", {
                        isFromExternalProduct: true,
                        purchaseDetail: purchaseDetail,
                        purchaseSubject: purchaseSubject
                    }, false)
                }
            })
        }
    }

    const btnChangeQty = (key: "-" | "+") => {
        const list = purchaseSubject.list

        const newList = list.map(el => {
            let count

            if (key === "-") {
                count = el.newIQty === 0 ? 0 : el.newIQty - 1
            } else {
                count = el.newIQty + 1
            }

            return { ...el, newIQty: count }
        })

        setValueSubject("list", newList)
    }

    useEffect(() => {
        if (appliedNewPShipment !== 0) {
            setValue("newPShipment", appliedNewPShipment)
        }
    }, [appliedNewPShipment]);

    // 내부수정: 배송방법 택배 고정
    useEffect(() => {
        if (shipmentList) {
            const value = shipmentList.find((el: any) => el.name.includes("택배"))?.id
            setValue("newPShipment", value)
        }
    }, [shipmentList]);

    useEffect(() => {
        if (purchaseDetail) {
            setValueSubject("list", [{
                ...pcsSubjectElementInit,
                newLErpProductValue: productDetail.newErpProductid,
                newTxtStandard: productDetail.newTxtStndItem,
                createdon: productDetail.createdon,
                newIQty: productDetail.newIQty === 0 ? 1 : (productDetail.newIQty ?? 1),
                productName: productDetail.newTxtNmItem,
                productRange: productDetail.productRange,
                newLProductGroupValue: productDetail.newLProductGroupValue,
                newProductGroupid: productDetail.newLProductGroupValue  // 내부수정: 제품군 id 누락 추가
            }])
        }
    }, [productDetail]);

    useEffect(() => {
        if (deliveryDestinationList.some(el => el.addressId === purchaseDetail.newLAddressValue)) {
            const data = deliveryDestinationList.find(el => el.addressId === purchaseDetail.newLAddressValue)

            setValue("newLAddressValue", data?.addressId ?? "");
            setValue("postCode", data?.newTxtPostalcode ?? "")
            setValue("addressName", data?.name ?? "");
            setValue("address1", data?.line1 ?? "");
            setValue("address2", data?.line2 ?? "");
        } else if (purchaseDetail.newLAddressValue === "") {
            setValue("newLAddressValue", "");
            setValue("postCode", "")
            setValue("addressName", "");
            setValue("address1", "");
            setValue("address2", "");
        }
    }, [purchaseDetail.newLAddressValue]);

    return <>
        <h5 className="subheading">상세 정보</h5>
        <div className="product_detail_container">
            <div className="left">
                <div className="img_outer">
                    {erpProductImageVO.fileKey && erpProductImageVO.fileKey !== "" && <>
                        <button className="btn btn-info color2 w-100px px-0 position-absolute"
                            onClick={btnImageDownload}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt="" />다운로드
                        </button>
                        {/* TODO: <img/> 태그로 변경, css 수정 필요 */}
                        <img
                            src={process.env.REACT_APP_SERVER_URL + `api/file/images_download?fileKey=${erpProductImageVO.fileKey}&fileUrl=${erpProductImageVO.fileUrl}&fileOrgname=${erpProductImageVO.fileOrgname}`}
                            alt=""
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }}
                        />
                        {/*<div style={{*/}
                        {/*    background: "url(" + process.env.REACT_APP_SERVER_URL + `/api/file/images_download?fileKey=${erpProductImageVO.fileKey}&fileUrl=${erpProductImageVO.fileUrl}&fileOrgname=${erpProductImageVO.fileOrgname}`,*/}
                        {/*    backgroundRepeat: "no-repeat",*/}
                        {/*    backgroundSize: "auto",*/}
                        {/*    backgroundPosition: "center"*/}
                        {/*}}></div>*/}
                    </>}
                </div>
                <AuthorityChecker authorityNames={['productWriteYn']}>
                    <FileUploadNoText addFileCallback={imageUpdateCallback}
                        customRenderer={(onClick, disabled) =>
                            <button className="btn btn-outline-secondary d-block m-auto w-140px h-38px"
                                onClick={onClick}
                                disabled={disabled}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_cam_sm.png"}
                                    alt="" />이미지 변경
                            </button>
                        }
                    />
                </AuthorityChecker>
            </div>
            <div className="right">
                <div className="right_top">
                    <table className="table table_form m-0 w-100 border-0">
                        <tbody>
                            <tr>
                                <td>적용환율</td>
                                <td>
                                    <div className="d-flex">
                                        <input type="text"
                                            className="form-control w-150px h-34px"
                                            value={searchProductWithAccountDetailRes.dailyAverageRate ?? ""}
                                            disabled
                                        />
                                        <input type="text"
                                            className="form-control w-150px h-34px ms-5px"
                                            value={searchProductWithAccountDetailRes.initialQuotedRate ?? ""}
                                            disabled
                                        />
                                        <input type="text"
                                            className="form-control w-150px h-34px ms-5px"
                                            value={searchProductWithAccountDetailRes.remittanceRate ?? ""}
                                            disabled
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>결제수단</td>
                                <td>현금</td>
                            </tr>
                            <tr>
                                <td>결제예정일</td>
                                <td>
                                    <input type="date"
                                        className="form-control w-150px h-34px"
                                        value={searchProductWithAccountDetailRes.paymentDueDate ?? ''}
                                        disabled
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>배송정보</td>
                                <td>{searchProductWithAccountDetailRes.shippingType}</td>
                            </tr>
                            <tr>
                                <td>배송비</td>
                                <td>{searchProductWithAccountDetailRes.shippingCost}</td>
                            </tr>
                            <AuthorityChecker authorityNames={['orderWriteYn']}>
                                <tr>
                                    <td>배송방법 <span className="required">*</span></td>
                                    <td>
                                        {/* 내부수정: 택배 고정
                                        <select className="form-select w-150px"
                                            value={purchaseDetail.newPShipment}
                                            {...register("newPShipment")}>
                                            <option value={0}>선택</option>
                                            {shipmentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                                        </select> */}
                                        <input type="text"
                                            className="form-control w-150px h-34px"
                                            value="택배"
                                            disabled/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="pt-15px" style={{ verticalAlign: "top" }}>배송지 <span
                                        className="required">*</span></td>
                                    <td>
                                        <div>
                                            <select className="form-select w-150px"
                                                value={purchaseDetail.newLAddressValue}
                                                {...register("newLAddressValue")}>
                                                <option value={""}>직접 입력</option>
                                                {deliveryDestinationList.map(el =>
                                                    <option value={el.addressId}>{el.name}</option>
                                                )}
                                                <option value={"-1"} hidden>주소 선택됨</option>
                                            </select>
                                        </div>
                                        <div className="d-flex mt-6px">
                                            <input type="text"
                                                className="form-control w-150px h-34px"
                                                placeholder="우편번호"
                                                value={purchaseDetail.postCode}
                                                disabled={purchaseDetail.newLAddressValue !== ""}
                                                {...register("postCode")}
                                            />
                                            <DaumPost onCompleteCallback={(data) => {
                                                setValue("newLAddressValue", "-1")
                                                setValue("postCode", data.zipcode);
                                                setValue("address1", data.address);
                                            }} />
                                            {/*<button className="btn btn-info btn_search ms-5px w-90px"*/}
                                            {/*        onClick={btnSearchAddress}>*/}
                                            {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>*/}
                                            {/*    주소 검색*/}
                                            {/*</button>*/}
                                            {/*<button className="btn btn-secondary w-80px ms-5px text-nowrap">주소 검색</button>*/}
                                            <input type="text"
                                                className="form-control ms-5px h-34px"
                                                placeholder="주소"
                                                value={purchaseDetail.address1}
                                                disabled={purchaseDetail.newLAddressValue !== ""}
                                                {...register("address1")}
                                            />
                                        </div>
                                        <div className="d-flex mt-6px">
                                            <input type="text"
                                                className="form-control h-34px"
                                                placeholder="상세 주소"
                                                value={purchaseDetail.address2}
                                                disabled={!(purchaseDetail.newLAddressValue === "" || purchaseDetail.newLAddressValue === "-1")}
                                                {...register("address2")}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>납품희망일 <span className="required">*</span></td>
                                    <td>
                                        <input type="date"
                                            className="form-control w-150px h-34px"
                                            max="9999-12-31"
                                            value={purchaseDetail.newDtRequestShipment}
                                            {...register("newDtRequestShipment")}
                                        />
                                    </td>
                                </tr>
                            </AuthorityChecker>
                        </tbody>
                    </table>
                </div>
                <AuthorityChecker authorityNames={['orderWriteYn']}>
                    <div className="right_btm">
                        <div className="right_btm_wrapper">
                            <div className="left">
                                <div className="line1">{productDetail.newTxtNmItem}</div>
                                <div className="line2">{productDetail.newTxtStndItem}</div>
                                <div className="input-group input_magic_control mb-3">
                                    <span className="input-group-text clickable" onClick={() => btnChangeQty("-")}>
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_minus_btn.png"} alt="" />
                                    </span>
                                    <input type="text" className="form-control"
                                        value={watchSubject("list").at(0)?.newIQty ?? 0} disabled />
                                    <span className="input-group-text clickable" onClick={() => btnChangeQty("+")}>
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_plus_btn.png"} alt="" />
                                    </span>
                                </div>
                            </div>
                            <div className="right">
                                {/* NOTE: 가격 없음 */}
                                {/*<div className="total">239,800원</div>*/}
                            </div>
                        </div>
                    </div>
                </AuthorityChecker>
                <div className="d-flex justify-content-end align-items-center mt-25px mb-15px">
                    {/* TODO: 장바구니 API 없음 */}
                    {/* <button className="btn btn-outline-dark w-100px h-38px px-0" onClick={btnCart}>
                        <img className="me-5px"
                             src={process.env.PUBLIC_URL + "/assets/images/icon_shopping_cart.png"}
                             alt=""/>장바구니
                    </button> */}
                    <AuthorityChecker authorityNames={['orderWriteYn']}>
                        <button className="btn btn-dark w-100px h-38px ms-5px" onClick={handleSubmit(btnBuy)}>구매하기
                        </button>
                    </AuthorityChecker>
                </div>
            </div>
        </div>
    </>
}